import { AlbumControl } from 'components/booklets/Album';
import { DBConfig, OrgName } from 'config';
import Page from './Page';

export function ChronicalsPage() {
	return <AlbumControl bookletId={DBConfig.ChronicalBooklet} />;
}
